import React from "react";
import "./index.scss";
import Title from "../common/Title";

const About = () => {
  return (
    <div className="page" id="about">
      <Title>About Me</Title>
      <div className="row">
        <div className="column">
          <strong>Hi, This is Prashant Patil</strong>
          <p>
            I am self-taught and self-driven individual, passionate about
            learning and developing technologies. Looking to create ingenious
            projects with a team of highly skilled individuals.
            <br /> <br />
            I’m the perfect person to help teams tackle challenging projects,
            and I’ll do it in a smooth and easygoing way.
            <br />
            <br />I am an enthusiastic learner and developer with specialties in
            Angular. React, Vue, Node. I’m excited to be working in the field on
            inventive teams who are looking for collaboration ideas.
          </p>
        </div>
      </div>
      <Title>My austerity of programming</Title>
      <div className="row">
        <div className="column">
          <p>
            I have a deep understanding of how JavaScript works, and I believe
            that having a solid understanding of core technologies makes
            developers more successful when they become experts at any
            framework.
          </p>
        </div>
      </div>
    </div>
  );
};

export default About;
